// extracted by mini-css-extract-plugin
export default {"footer":"MnE1ul","associatedPermissionsBanner":"AE25d0"};